export const NATIVE_TOOL_NAMES: ReadonlySet<string> = new Set([
  'file_read',
  'file_write',
  'file_edit',
  'file_append',
  'file_delete',
  'file_move',
  'file_list',
  'file_info',
  'grep',
  'bash',
  'workspace_init',
  'skill_list',
  'skill_search',
  'skill_read',
  'skill_create',
  'skill_update',
  'skill_delete',
  'model_default',
  'provider_list',
  'model_list',
  'process_list',
  'search',
  'cloud_save_version',
  'cloud_view_unsaved',
  'cloud_list_versions',
  'cloud_restore_version',
  'context_search',
  'result_read',
  'result_search',
  'context_window',
  'context_read',
  'context_agents',
  'context_pin',
  'context_unpin',
  'context_list',
  'list_teams',
  'board_view',
  'list_tickets',
  'get_ticket',
  'create_ticket',
  'transition_state',
  'assign_ticket',
  'add_comment',
  'docs_search',
  'docs_read',
  'platform_call',
  'triage',
  'explore',
  'research',
  'plan',
  'evaluate',
  'audit',
  'delegate',
  'execute_plan',
  'list_agents',
]);

export function isNativeTool(toolName: string): boolean {
  return NATIVE_TOOL_NAMES.has(toolName);
}
